var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{class:_vm.componentStyles},[(_vm.linkOnly)?_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2):_c('b-row',[_c('b-col',[_c('a',{class:_vm.linkStyles,attrs:{"href":_vm.searchPageUri}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.linkText))]})],2)])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3b496f6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/aha-back-to-search.vue
// module id = 877
// module chunks = 0